import { PhoneNumber } from '../data/models/phone-number.model';
import phoneUtils from '../services/phoneUtils';

export const usePhone = (
  phoneNumber: PhoneNumber | undefined = undefined,
  withExtension = true,
): string => {
  return phoneUtils.formatPhone(phoneNumber, withExtension);
};
